exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-full-page {\n  height: 100%; }\n  .error-full-page img.error-background {\n    min-height: 100%;\n    min-width: 1024px;\n    width: 100%;\n    height: auto;\n    position: fixed;\n    top: 0;\n    left: 0; }\n  .error-full-page img.spaceman {\n    width: auto;\n    position: fixed;\n    right: 0;\n    bottom: 50px; }\n  .error-full-page .error-text {\n    text-align: center;\n    color: #ffffff;\n    opacity: 0.88; }\n  .error-full-page .error-header {\n    font-size: 36px;\n    font-weight: 700;\n    line-height: 48px; }\n  .error-full-page .error-blurb {\n    font-size: 24px;\n    line-height: 34px;\n    margin-top: 11px; }\n  @media (max-width: 1251px) {\n    .error-full-page img.error-background {\n      width: inherit; }\n    .error-full-page img.spaceman {\n      width: 50%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Error/errorDisplay.scss
// module id = 1325
// module chunks = 1